import { supabase } from '../lib/supabase';

export async function createGroup(name: string, ttlHours?: number): Promise<string> {
  const trimmed = name.trim();
  if (!trimmed) throw new Error('Group name is required');
  const { data, error } = await supabase.rpc('create_group', {
    p_name: trimmed,
    p_ttl_hours: ttlHours && ttlHours > 0 ? Math.floor(ttlHours) : null,
  });
  if (error) throw error;
  if (!data) throw new Error('Failed to create group');
  return data as string;
}

export async function joinGroupByCode(code: string): Promise<string> {
  const normalized = code.trim().toUpperCase();
  if (!normalized) throw new Error('Join code is required');
  const { data, error } = await supabase.rpc('join_group_by_code', { code: normalized });
  if (error) throw error;
  if (!data) throw new Error('No group found for that code');
  return data as string;
}
